<div
  *ngIf="!hideHeader"
  [ngClass]="{ platform: (isPlatform$ | async) === true, mobile: (device$ | async) === 'mobile', scrolled: isScrolled }">
  <ng-container *ngIf="(device$ | async) === 'mobile'; else desktop">
    <sh-main-nav-mobile></sh-main-nav-mobile>
  </ng-container>
  <ng-template #desktop>
    <ng-container *ngIf="(hasUser$ | async) === true; else noUser">
      <sh-main-nav-platform-desktop *ngIf="(isPlatform$ | async) === true"></sh-main-nav-platform-desktop>
      <sh-main-nav-business-desktop-for-user
        *ngIf="(isPlatform$ | async) === false"
        [bigger]="!isScrolled"></sh-main-nav-business-desktop-for-user>
    </ng-container>
    <ng-template #noUser>
      <sh-main-nav-platform-desktop *ngIf="(isPlatform$ | async) === true"></sh-main-nav-platform-desktop>
      <sh-main-nav-business-desktop
        *ngIf="(isPlatform$ | async) === false"
        [bigger]="!isScrolled"></sh-main-nav-business-desktop>
    </ng-template>
  </ng-template>
</div>
